import { useNavigate, useLocation } from "react-router-dom";
import { getMenuParent, MENU_ROOT } from "../utility/menuParent";

/**
 * useMenuBack — returns a `goBack` handler that navigates to the current page's
 * MENU PARENT (the next page UP in the menu chain) instead of the browser-history
 * previous page.
 *
 * Resolution order (see utility/menuParent.ts):
 *   1. an explicitly mapped parent (list page / section landing), else
 *   2. MENU_ROOT ("/dashboard") — the top of every menu chain.
 * Browser history is never used, so "back" is deterministic regardless of how
 * the user arrived on the page.
 *
 * Usage (drop-in for the old `const goBack = () => { window.history.back(); }`):
 *   const goBack = useMenuBack();
 *   ...onClick={goBack}
 */
export function useMenuBack() {
  const navigate = useNavigate();
  const location = useLocation();
  return () => {
    navigate(getMenuParent(location.pathname) || MENU_ROOT);
  };
}

export default useMenuBack;
